import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/_stats-layout/stats/')({
    beforeLoad: () => {
        throw redirect({
            to: '/stats/by-date',
        })
    },
})
